import { Router } from '@reach/router';
import React from 'react';
import Helmet from 'react-helmet';
import AccountLayout from '../../components/account-layout';
import { useTranslation } from '../../hooks/useTranslation';
import ROUTES from '../../routes';
import MyPricingPlan from '../../components/my-pricing-plan';

export const MyPricingPlanMain = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('MY_PRICING_PLAN_OPTIONS')}</title>
      </Helmet>
      <AccountLayout>
        <Router basepath="/">
          <MyPricingPlan path={`${ROUTES.MY_PRICING_PLAN}/*`} />
        </Router>
      </AccountLayout>
    </>
  );
};
export default MyPricingPlanMain;
